import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Reusable function to show toast notifications
export const showToast = (message, type = "default", duration = 3000) => {
  switch (type) {
    case "success":
      toast.success(message, { autoClose: duration });
      break;
    case "error":
      toast.error(message, { autoClose: duration });
      break;
    case "info":
      toast.info(message, { autoClose: duration });
      break;
    case "warning":
      toast.warn(message, { autoClose: duration });
      break;
    default:
      toast(message, { autoClose: duration });
  }
};

// usage
// showToast("sdsdsd", "error");
